"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdditionalPlanParser = void 0;
var _services = require("../../../services");
var _constants = require("../../constants");
class AdditionalPlanParser {
  constructor(plan, numberOfPlans, maximumAdditionalPlans) {
    this.plan = void 0;
    this.numberOfPlans = void 0;
    this.maximumAdditionalPlans = void 0;
    this.plan = plan;
    this.numberOfPlans = numberOfPlans;
    this.maximumAdditionalPlans = maximumAdditionalPlans;
  }
  get getTexts() {
    const mainPriceBeforeDiscount = this.getPriceByPriceType(_constants.PRICE_TYPES.LIST_ADDITIONAL_PLAN_PRICE);
    const mainPriceAfterDiscount = this.getPriceByPriceType(_constants.PRICE_TYPES.COMMERCE_ADDITIONAL_PLAN_PRICE);
    const hideDiscount = mainPriceBeforeDiscount.priceValue === mainPriceAfterDiscount.priceValue;
    const MainTextLarge = `${_services.locale.formatPrice(mainPriceAfterDiscount.priceValue)}`;
    const MainTextNormal = `/${_services.locale.localeString('Recommendation.month')}`;
    const BottomTextNormal = _services.locale.localeString('Recommendation.RightStackBottomTextTemplate', {
      amount: mainPriceAfterDiscount.durationAmount,
      unit: _services.locale.localeString('Recommendation.month'),
      price: _services.locale.formatPrice(mainPriceBeforeDiscount.priceValue),
      pluralUnit: _services.locale.localeString('Recommendation.Month')
    });
    const discountAmount = Math.round(100 * (1 - mainPriceAfterDiscount.priceValue / mainPriceBeforeDiscount.priceValue));
    return {
      mainText: {
        large: MainTextLarge,
        normal: MainTextNormal
      },
      subText: hideDiscount ? '' : BottomTextNormal,
      discountAmount,
      pillText: !!discountAmount && _services.locale.localeString('Recommendation.DiscountText', {
        amount: discountAmount
      })
    };
  }
  get buttons() {
    return {
      left: {
        text: _services.locale.localeString('Recommendation.decrement'),
        state: this.numberOfPlans === 0
      },
      right: {
        text: _services.locale.localeString('Recommendation.increment'),
        state: this.numberOfPlans === this.maximumAdditionalPlans
      }
    };
  }
  get incrementComponentText() {
    const textOfAdditionalPlans = this.numberOfPlans === 1 ? 'Recommendation.numberOfAdditionalOnePlan' : 'Recommendation.numberOfAdditionalPlans';
    return this.numberOfPlans === 0 ? _services.locale.localeString('Recommendation.addAdditionalPlan') : _services.locale.localeString(textOfAdditionalPlans, {
      number: this.numberOfPlans
    });
  }
  getPriceByPriceType(priceType) {
    return this.plan.selectedVariant.price.find(price => {
      return price.priceType === priceType;
    }) || {};
  }
  showAdditionalPlanData(props) {
    return !props.isCustomer;
  }
}
exports.AdditionalPlanParser = AdditionalPlanParser;